import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import CookieConsentBanner from './CookieConsentBanner';

// Route-level code splitting
const HomePage = lazy(() => import('./Website/HomePage'));
const VideosPage = lazy(() => import('./Website/VideosPage'));
const AboutPage = lazy(() => import('./Website/AboutPage'));
const MyteAITrainingCourses = lazy(() => import('./Website/MyteAITrainingCourses'));
const SphereFlow = lazy(() => import('./SubscriptionFunnel/SphereFlow'));

/**
 * MarketingApp
 * Central router for all marketing site pages.
 */
export default function MarketingApp() {
  return (
    <>
      <CookieConsentBanner />
      <Suspense fallback={<div className="p-8 text-center">Loading...</div>}>
        <Routes>
          <Route index element={<HomePage />} />
          <Route path="videos" element={<VideosPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="joinMyte/*" element={<SphereFlow />} />
          <Route path="MyteAITrainingCourses" element={<MyteAITrainingCourses />} />
        </Routes>
      </Suspense>
    </>
  );
}